import api_fetch from "../utils/api_fetch";
import { storageHandler } from '../utils/storage_handler';

const amexOffers = {
    // Get an offer by its ID
    getOfferById: async function(id) {
        try {
            const response = await api_fetch.get(`/v1/amex-offer/${id}`, {
                Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
            });
            return response.json();
        } catch (error) {
            console.error("Error fetching offer by ID:", error);
            throw error;
        }
    },

    // Get a list of offers with pagination and search
    getOffers: async function(page = 1, pageSize = 10, searchKeyword = '', userId = '') {
        try {
            const response = await api_fetch.get(`/v1/amex-offers/`, {
                Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
            }, { 
                page: page, pageSize: pageSize, searchKeyword: searchKeyword || '', userId: userId || ''
            }, "");
            return response.json();
        } catch (error) {
            console.error("Error fetching offers:", error);
            throw error;
        }
    },

    // Get a list of unique users who have offers
    getUniqueUsers: async function() {
        try {
            const response = await api_fetch.get('/v1/amex-offers/users', {
                Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
            }, {}, "", {});
            return response.json();
        } catch (error) {
            console.error("Error fetching unique users:", error);
            throw error;
        }
    },

    getOfferFiles: async function(page = 1, pageSize = 10, keyword = '', orderBy = 'date', orderDirection = 'asc', format = 'type_csv') {
        // Prepare the query parameters
        const queryParams = {
            page: page,
            pageSize: pageSize,
            keyword: keyword,
            orderBy: orderBy,
            orderDirection: orderDirection,
            format: format  // Include the format parameter here
        };
    
        // Call the api_fetch.get function with the query parameters
        return (await api_fetch.get('/v1/get-offer-files', {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, queryParams, "", {})).json();
    },    

    downloadFile: async function(cardNo, fileName) {
        const fileLink = `/v1/download-offer-file/${cardNo}/${fileName}`;
        // Trigger file download using the generated link
        const response = await api_fetch.get(fileLink, {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, "", {});
        if (response.ok) {
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName; // Set the filename for download
            link.click(); // Trigger the download
        } else {
            console.error("Failed to download file");
        }
    },

    // Get Amex offers for a Corteza customer by record_id
    getOffersForCustomer: async function(record_id) {
        try {
            const response = await api_fetch.get(`/v1/amex-offers/customer/${record_id}`, {
                Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
            }, {}, ""); // Always pass empty object for query_json
            return response.json();
        } catch (error) {
            console.error("Error fetching offers for customer:", error);
            throw error;
        }
    }
}

export default amexOffers;
